import { cloneDeep } from 'lodash';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { PosterType } from '@meitu/saas-editor-core/es/version-types';
import { editor } from '@/instance';
import { FetchTemplateDetailDetailType } from '@/types';

export interface RecordInfo {
    /** 数据类型 */
    fetchType?: FetchTemplateDetailDetailType;
    id?: number;
    material_id?: number;
    category_id?: number;
    threshold?: number;
    /** 作图记录保存时间 */
    updated_at?: number;
    /** 用于获取分享信息 */
    shareOtherId?: number;
    /** 分享的作图记录作者 */
    share_author?: number;
    /** 分享key (分享目录下的作图记录不一定有share_key, 但is_shared一定为true) */
    share_key?: string | null;
    /** 是否可以创建分享 */
    noCreateSharePermission?: boolean;
    /** 是否被分享 */
    is_shared?: boolean;
    /** 文件保存的文件夹路径 */
    current_node?: string;
    /** 是否不可复制 (创建副本) */
    copyIsDisabled?: boolean;
}

export interface IRecordType {
    destroy: () => void;
    recordInfo: RecordInfo;
    setRecordInfo: (payload: RecordInfo) => void;
    getRecordInfo: () => RecordInfo;

    /** 海报保存类型 */
    posterType: PosterType;
    setPosterType: (payload: PosterType) => void;
    getPosterType: () => PosterType;

    recentId: undefined | number;
    setRecentId: (payload: undefined | number) => void;
}

const defaultRecordInfo = {
    fetchType: FetchTemplateDetailDetailType.TYPE_TEMPLATE,
    id: undefined,
    material_id: 0,
    category_id: undefined, // 分类ID
    threshold: 0, //模板门槛
    updated_at: undefined,
    share_author: undefined,
    share_key: undefined,
    current_node: undefined,
    copyIsDisabled: false,
};

// 用户记录信息
const useRecordModel = create<IRecordType>()(
    immer((set, get) => ({
        destroy: () =>
            set((state) => {
                state.recordInfo = cloneDeep(defaultRecordInfo);
                state.posterType = PosterType.Poster;
            }),
        posterType: PosterType.Poster,
        setPosterType: (payload) =>
            set((state) => {
                state.posterType = payload;
                editor.setPosterType(payload);
            }),
        getPosterType: () => get().posterType,

        recordInfo: cloneDeep(defaultRecordInfo),
        setRecordInfo: (payload) =>
            set((state) => {
                state.recordInfo = { ...state.recordInfo, ...payload };
            }),
        getRecordInfo: () => cloneDeep(get().recordInfo),
        recentId: undefined,
        setRecentId: (payload) =>
            set((state) => {
                state.recentId = payload;
            }),
    })),
);

export { useRecordModel };
export const getRecordModel = () => useRecordModel.getState();
